import { Directive } from '@angular/core';
import { OnInit } from '@angular/core';
import { Input } from '@angular/core';
// import { DateComponent } from "src/app/components/date.component/date.component";
import { ViewContainerRef } from '@angular/core';
import { OnDestroy } from '@angular/core';
import { Validator } from '../core/model';
import { AppConfig } from 'src/app/app-config.module';

@Directive({
    selector: '[required-date-validator]',
    exportAs: 'validator'
})
export class DateValidatorDirective implements OnInit, OnDestroy, Validator
{
    @Input('required-date-validator')
    public getValue: () => string; // Not really used but necessary...

    private host: any; // DateComponent;
    private hostCancelToken: { cancel: () => void };
    private readonly elementRef: any;

    public valid = undefined;

    // public constructor(
    //    host: any, //DateComponent,
    //    config: AppConfig,
    //    viewRef: ViewContainerRef)
    // {
    //    this.host = host;
    //    this.config = config;
    //    this.elementRef = viewRef.element.nativeElement;
    // }

    public ngOnInit(): void
    {
        const _this = this;
        const onListen = () =>
        {
            _this.validate();
        };

        this.hostCancelToken = this.host.attachListener(onListen);
    }

    public ngOnDestroy(): void
    {
        if (this.hostCancelToken != null)
        {
            this.hostCancelToken.cancel();
        }
    }

    public sniff(): boolean
    {
        return this.isValid();
    }

    public validate(): boolean
    {
        this.valid = this.isValid();
        return this.valid;
    }

    private isValid(): boolean
    {
        const selectedDate = this.host.selectedDate;

        const { day, month, year } = selectedDate;

        // const birthSpanMin = this.config.allowedBirthDateRange.min;
        // const birthSpanMax = this.config.allowedBirthDateRange.max;

        const visitorBirthdate = new Date(year, month, day);
        const earliestAllowedBirthDate = new Date(); // new Date(birthSpanMin.year, birthSpanMin.month - 1, birthSpanMin.day);
        const latestAllowedBirthDate = new Date();  // new Date(birthSpanMax.year, birthSpanMax.month - 1, birthSpanMax.day);

        return (+visitorBirthdate >= +earliestAllowedBirthDate) && (+visitorBirthdate <= +latestAllowedBirthDate);
    }

    public get element(): any
    {
        return this.elementRef;
    }

}


